import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { GetSetsRequest } from "../models/subjects/getSetsRequest"
import { SubjectsSetsGradesResponse } from "../models/subjects/subjectsSetsGradesResponse"

@Injectable()
export class SubjectsService {
  private post_subjects_get_sets_url: string

  constructor(private httpClient: HttpClient) {
    const url = environment.endpointSubjects.url

    this.post_subjects_get_sets_url =
      url + environment.endpointSubjects.routes.post_subjects_get_sets
  }

  postSubjectsGetSets(data: GetSetsRequest) {
    return this.httpClient.post<{ sets: SubjectsSetsGradesResponse[] }>(
      this.post_subjects_get_sets_url,
      data
    )
  }
}
